import { isVietnamCompany } from './vietnam';

// CPI-1208: a Vietnamese unit layout records six things a Malaysian one does not - Block,
// Direction, View, Floor and the two areas NFA and NSA. Everything here is unchanged elsewhere.
export const VN_LAYOUT_FIELDS = ['block', 'direction', 'view', 'floor', 'nfa', 'nsa'];

export const VN_LAYOUT_DEFAULT_VALUES = {
  block: '',
  direction: '',
  view: '',
  floor: '',
  nfa: 0,
  nsa: 0,
};

// The numeric fields have to leave the form as numbers; nfa and nsa are added for Vietnam only.
// An empty box is 0, never NaN - NaN serialises to null and the API would refuse the write.
export const parseLayoutFormValues = (unitLayout, isVietnam) => Object.assign(unitLayout, {
  size: parseFloat(unitLayout.size),
  landArea: parseFloat(unitLayout.landArea),
}, isVietnam ? {
  nfa: parseFloat(unitLayout.nfa) || 0,
  nsa: parseFloat(unitLayout.nsa) || 0,
} : {});

// CPI-1244 item 11's empty-state rule: a layout field with no value shows a dash, not a stray 0.
export const layoutFieldDisplay = (value) => {
  if (value === null || value === undefined || value === '' || value === 0) {
    return '-';
  }
  return value;
};

// CPI-1208 item 6 / Q4: the five specification presets are seeded rows with no company column,
// so they are offered for a Vietnamese company only.
const VN_LAYOUT_SPECIFICATION_PRESETS = [
  'structure',
  'ceiling',
  'windows',
  'ironmongery',
  'carpark',
];

export const visibleLayoutSpecifications = (auth, specifications) => {
  const list = specifications || [];
  if (isVietnamCompany(auth)) {
    return list;
  }
  return list.filter(s => !s || VN_LAYOUT_SPECIFICATION_PRESETS.indexOf(s.id) === -1);
};

// CPI-1208 post-fix (PO, 6 Sep): "ensure to hide the old one from the UI." A Vietnamese layout
// keeps `size` and `landArea` in the database - nothing stops writing them - but no Vietnamese
// screen shows them: the pair a VN screen reads is NSA and NFA. These two are the single place
// that decides which pair a screen reads, so the form, the list row, the detail header and the
// Compare screen cannot drift. Outside Vietnam each returns exactly the field the screen read
// before.
export const layoutAreaValue = (isVietnam, unitLayout) => (
  isVietnam ? (unitLayout || {}).nsa : (unitLayout || {}).size
);

export const layoutLandAreaValue = (isVietnam, unitLayout) => (
  isVietnam ? (unitLayout || {}).nfa : (unitLayout || {}).landArea
);



// WEBPACK FOOTER //
// ./src/utils/unitLayout.js